import { debug, utils } from 'lib';
import { UiToast } from 'components';
import joinLineLib from '../join-line';

const log = debug.create('joinLine');

const handle = (socket) => {
  // 发起邀请事件 join_line.invite
  // 拒绝邀请事件 join_line.refuse_invite
  // 邀请成功事件 join_line.success_invite

  // 取消邀请事件 join_line.cancel_invite
  // 加入连麦事件 join_line.join_chatting
  // 退出连麦事件 join_line.exit_chatting

  // 心跳告警事件 join_line.heart_warn
  // 连麦关闭事件 join_line.close

  // 收到邀请
  socket.on('join_line.invite', () => {
    joinLineLib.reload();
  });
  socket.on('join_line.invite_timeout', (msg, { room }) => {
    if (room.roomId === msg.data.from._id) {
      UiToast.warn(`邀请[${msg.data.target.nick_name}]超时`);
    }
    joinLineLib.reload();
  });
  socket.on('join_line.match_timeout', (msg) => {
    UiToast.warn(`匹配超时`);
    joinLineLib.reload();
  });

  // 发给房间
  socket.on('join_line.success_invite', (msg, { room }) => {
    room.update();
    if (room.isRoomOwner) {
      UiToast.success(`[${msg.data.from.nick_name}]加入连麦`);
      joinLineLib.reload();
    }
  });

  socket.on('join_line.refuse_invite', (msg) => {
    UiToast.warn(`对方[${msg.data.from.nick_name}]已拒绝`);
    joinLineLib.reload();
  });
  socket.on('join_line.cancel_invite', (msg) => {
    UiToast.warn(`对方[${msg.data.from.nick_name}]已取消`);
    joinLineLib.reload();
  });
  socket.on('join_line.join_chatting', (msg, { room, lianmai: { joinLine } }) => {
    room.update();
    if (room.isRoomOwner) {
      joinLineLib.reload();
    }

    log('join_chatting', joinLine.info.toJSON(), room.roomInfo.toJSON());
  });
  socket.on('join_line.exit_chatting', (msg, { room, lianmai: { joinLine } }) => {
    room.update();

    log('exit_chatting', joinLine.info.toJSON(), room.roomInfo.toJSON());
    if (room.isRoomOwner && room.roomId !== msg.data.from.id) {
      joinLineLib.reload();
      UiToast.success(`[${msg.data.from.nick_name}]已退出连麦`);
    }
  });

  socket.on('join_line.pk.first', (msg) => {
    joinLineLib.loadInfo();
  });

  socket.on('join_line.pk.second', (msg) => {
    joinLineLib.loadInfo();
  });

  socket.on('join_line.pk.third', (msg) => {
    joinLineLib.loadInfo();
  });

  socket.on('join_line.pk.fourth', (msg) => {
    joinLineLib.loadInfo();
  });
  socket.on('join_line.voice_switch', (msg, { room }) => {
    room.update();
  });
  // {
  // 			"duration":当前阶段持续时间
  // 			"value": 主播更新之后的pk值
  // 		}
  socket.on('join_line.pk.star_value_update', (msg, { lianmai: { joinLine } }) => {
    joinLine.info.mode_info.updatePkValue(msg.data.room_id, msg.data.pk_value, msg.data.top_room);
    // joinLineLib.loadInfo()
  });
  // {
  // 			"duration":当前阶段持续时间
  // 			"list": 数组对象
  // 					{
  // 						uid  用户id
  // 						pic 用户头像
  // 						value  用户贡献值
  // 					}
  // 		}
  socket.on('join_line.pk.user_rank_update', (msg, { lianmai: { joinLine } }) => {
    joinLine.info.mode_info.updateTopUser(msg.data.room_id, msg.data.top_user);
    // joinLineLib.loadInfo()
  });
  socket.on('join_line.pk.heart_warn', (msg, { room, lianmai: { joinLine } }) => {
    log('heart_warn', joinLine.info.toJSON(), room.roomInfo.toJSON());
    // joinLineLib.loadInfo()
  });
  socket.on('join_line.end_time', (msg) => {
    UiToast.warn(`连麦成功，本次连麦在${utils.formatTime(msg.data.end_time, 'hh:mm')}自动关闭`);
  });
  socket.on('join_line.end_residue_second', (msg) => {
    UiToast.warn(`连麦时间剩余${msg.data.residue_second}S，到时将自动结束`);
  });
};

export default handle;
